/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
import { List$1 } from "igniteui-react-core";
import { CellModelExport } from "./CellModelExport";
import { StringBuilder } from "igniteui-react-core";
/**
 * @hidden
 */
var GridLayerExport = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridLayerExport, _super);
    function GridLayerExport(a) {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.c = null;
        _this.c = a;
        _this.a = new List$1(CellModelExport.$, 0);
        return _this;
    }
    Object.defineProperty(GridLayerExport.prototype, "b", {
        get: function () {
            return this.a;
        },
        enumerable: true,
        configurable: true
    });
    GridLayerExport.prototype.e = function (a) {
        this.a.add(a);
    };
    GridLayerExport.prototype.f = function () {
        this.a.clear();
    };
    GridLayerExport.prototype.d = function () {
        var a = new StringBuilder(0);
        a.u("{");
        a.u("name: \"" + this.c + "\", cells: [");
        for (var b = 0; b < this.a.count; b++) {
            a.l(this.a._inner[b].ab());
            if (b < this.a.count - 1) {
                a.l(", ");
            }
        }
        a.l("]");
        a.l("}");
        return a.toString();
    };
    GridLayerExport.$t = markType(GridLayerExport, 'GridLayerExport');
    return GridLayerExport;
}(Base));
export { GridLayerExport };
//# sourceMappingURL=GridLayerExport.js.map
